module.exports = __webpack_public_path__ + "media/night/386-e25fd98d.svg";